var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.student
        ? _c("medical-plan", {
            attrs: {
              "consent-services": _vm.consentServices,
              "is-read-only": "",
              services: _vm.services,
              "sign-services": _vm.signServices,
              "signature-hub-services": _vm.signatureHubServices,
              student: _vm.student
            },
            on: { back: _vm.back }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }